var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LoadBlockController } from "./load_block_controller";
import { useInterval } from "../../mixins/use_interval";
export class PollBlockController extends LoadBlockController {
    connect() {
        if (!this.hasSecondsValue) {
            throw new Error("Required value `seconds` is missing");
        }
        requestAnimationFrame(() => {
            this._timeout();
            useInterval(this, this._timeout, this.secondsValue * 1000);
        });
    }
    _timeout() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadContent();
        });
    }
}
PollBlockController.targets = ["replace"];
PollBlockController.values = {
    endpoint: String,
    errorMessage: String,
    selector: String,
    maxRetries: Number,
    seconds: Number,
};
